/**
 * @generated SignedSource<<babbd8a8eafed795c0a8060a15a7e54e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkActiveEarnCashback_charge$data = {
  readonly cashback: {
    readonly percentage: number | null | undefined;
    readonly status: string | null | undefined;
    readonly value: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PaymentLinkActiveEarnCashback_charge";
};
export type PaymentLinkActiveEarnCashback_charge$key = {
  readonly " $data"?: PaymentLinkActiveEarnCashback_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActiveEarnCashback_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkActiveEarnCashback_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Cashback",
      "kind": "LinkedField",
      "name": "cashback",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "2c5ccac862cb8ff13907f57285c981ea";

export default node;
